import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { getRecord, getList } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

import { NO_COLUMNS } from "appConstants";

export function useBins(location) {
  const [bins, setBins] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (location) {
      async function getBinInfo() {
        try {
          const { bins } = await getRecord("location", location.id);
          setBins(bins);
        } catch (e) {
          handleProgramError(e);
        }
      }
      getBinInfo();
    } else {
      async function getAllBins() {
        const bins = await getList("bins", { columns: NO_COLUMNS });
        // "normalizing" the bins into our standard id/name
        // structure so it can be used by our standard components
        const mappedBins = bins.map(({ id, number, location }) => ({
          id,
          name: number,
          location,
        }));
        setBins(mappedBins);
      }
      getAllBins();
    }
  }, [location, dispatch]);

  return bins;
}
